/*
 *
 * Api reducer
 *
 */

import produce from 'immer';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { ACCOUNT_FETCH_BALANCES } from './constants';


export const initialState = {
    balances : {}
};

export const accountReducer = (state = initialState, action) => {

    return produce(state, draft => {
        switch (action.type) {
            case REQUEST_DATA_RESULT:
                switch (action.id) {
                    case ACCOUNT_FETCH_BALANCES:
                        draft.balances = action.result;
                        break;

                }
        }
    });
}